var Theme = Theme || {};

Theme.MyProfile = (function ($) {

    return {
        init: _init
    };

    function _init() {
        initMyEditableProfile();
        initUserProfileEvents();
    }

    function initMyEditableProfile() {
        $('.btn-edit-userprofile').on('click', _editUserProfile);
        $('.btn-edit-useremail').on('click', _editUserEmail);
    }

    function initUserProfileEvents() {
        $('.btn-userprofile-update').on('click', _updateUserProfile);
        $('.btn-userprofile-cancel').on('click', _cancelUserProfile);

        $('.userprofile-countries').on('change', function () {
            var selectedCountryId = $(this).find(':selected').val();
            _getUserProfileStates(selectedCountryId);
        });

        $('#js-radio-is-licensed-physician, #js-radio-is-not-licensed-physician').on('change', function () {
            var isLicensedPhysician = $(this).val();
            _getUserProfileProfessions(isLicensedPhysician);
        });

        $('.js-userprofile-professions').on('change', function () {
            var selectedProfessionId = $(this).find(':selected').val();
            _getUserProfileSpecialtys(selectedProfessionId);
        });

        var $extendedPasswordRequirementsControl = $('#extendedPasswordRequirementsEnabled'); 
        if ($extendedPasswordRequirementsControl.length && $extendedPasswordRequirementsControl.val() === 'True') {
            SCM.MyAccount.initTestPasswordWithExtendedRequirements();
        }
        else
        { 
            SCM.MyAccount.initTestPassword();
        }
    }

    function initUserEmailEditEvents() {
        $('.btn-useremail-update').on('click', _updateUserEmail);
        $('.btn-useremail-cancel').on('click', _cancelUserProfile);
    }

    function _editUserProfile() {
        var ajaxUrl = '/Content/EditUserProfile/editUserProfile';

        SCM.Ajax.get(ajaxUrl)
            .expectHtml()
            .then(_showEditableUserProfile)
            .catch(console.error);
    }

    function _showEditableUserProfile(ajaxResult) {
        var $userProfileContainer = $('#myaccount-tabs-content');
        if (ajaxResult != undefined && ajaxResult.length) {
            $userProfileContainer.html(ajaxResult).show();
            initUserProfileEvents();
        }
    }
    
    function _updateUserProfile() {
        var $button = $('.btn-userprofile-update');
        if ($button.hasClass('disabled')) {
            return;
        }

        var ajaxUrl = '/UserDashboard/UpdateUserProfile/updateUserProfile';

        var userDefinedFields = {};
        var $fieldList = $('.js-fieldList');
        if ($fieldList.length) {
            for (var i = 0; i < $fieldList.length; i++) {
                userDefinedFields[parseInt($fieldList[i].dataset.cfdid)] = $fieldList[i].value;
            }
        }

        var $formContainer = $('.editable-userprofile-info');

        $formContainer.find('input').removeAttr('aria-invalid');
        $formContainer.find('.error-message').html('').addClass('hide');

        var userProfile = {
            FirstName: $('#userprofile-firstname').val(),
            LastName: $('#userprofile-lastname').val(),
            UserName: $('#userprofile-username').val(),
            OldPassword: $('#OldPassword').val(),
            Password: $('#Password').val(),
            ConfirmPassword: $('#ConfirmPassword').val(),
            Organization: $('#userprofile-organization').val(),
            HomePhone: $('#userprofile-homephone').val(),
            WorkPhone: $('#userprofile-workphone').val(),
            MobilePhone: $('#userprofile-mobilephone').val(),
            FaxNumber: $('#userprofile-fax').val(),
            Suffix: $('#userprofile-suffix').val(),
            Address: $('#userprofile-address').val(),
            Address2: $('#userprofile-address2').val(),
            City: $('#userprofile-city').val(),
            PostalCode: $('#userprofile-postalcode').val(),
            StateId: $('.userprofile-states :selected').val(),
            CountryId: $('.userprofile-countries :selected').val(),
            Title: $('#userprofile-title').val(),
            EmailAddress: $('#userprofile-emailaddress').val(),
            SpecialtyId: $('.js-userprofile-specialities :selected').val(),
            ProfessionId: $('.js-userprofile-professions :selected').val(),
            Specialty: $('.js-userprofile-specialities :selected').text(),
            Profession: $('.js-userprofile-professions :selected').text(),
            WorkSetting: $('.js-userprofile-work-settings :selected').text(),
            IsLicensedPhysician: $('#js-radio-is-licensed-physician').prop('checked'),
            VendorId: $('#js-user-vendor-id').val(),
            UserSpecificClientFields: userDefinedFields,
            CaptchaResponse: SCM.Captcha.GetCaptchaResponse($formContainer),
            ReceivesMarketingEmailAlert: $('#js-radio-signed-up-for-marketing-emails').prop('checked')
        };

        $button.prop('disabled', true).addClass('disabled is-processing');

        SCM.Ajax.post(ajaxUrl, userProfile)
            .expectActionResultModel()
            .ensureSuccess()
            .then(_getUpdatedProfile)
            .catch(_updateProfileError);
    }

    function _updateProfileError(ajaxError) {
        $('.btn-userprofile-update').prop('disabled', false).removeClass('disabled is-processing');

        var actionResult = ajaxError.actionResultModel;
        var $formContainer = $('.editable-userprofile-info');

        if (actionResult.ValidationErrors?.length) {
            $.each(actionResult.ValidationErrors, function (index, value) {
                $(`#ErrorMessage${value.Key}`)
                    .removeClass('hide')
                    .html(value.Errors.join(' '));

                $(`.js-${value.Key}`).attr('aria-invalid', 'true');
            });
        }

        SCM.Captcha.ResetCaptcha($formContainer);
    }
    
    function _getUpdatedProfile(ajaxResponse) {
        var ajaxUrl = '/Content/MyProfile/myProfile';
        var successHtml = ajaxResponse.Html;
        SCM.Ajax.get(ajaxUrl)
            .expectHtml()
            .then(_showUpdatedProfile)
            .then(function (result) {
                _revealSuccessMsg(successHtml);
            })
            .catch(console.error);

    }

    function _showUpdatedProfile(ajaxResult) {
        var userProfileContainer = $('#myaccount-tabs-content');
        if (ajaxResult != undefined && ajaxResult.length) {
            userProfileContainer.html(ajaxResult).show();
            initMyEditableProfile();
        }
    }

    function _revealSuccessMsg(successHtml) {
        $('.success').removeClass('hide');
        if (successHtml.length) {
            $('.success').html(successHtml);
        }
    }

    function _cancelUserProfile() {
        var ajaxUrl = '/Content/MyProfile/myProfile';

        SCM.Ajax.get(ajaxUrl)
            .expectHtml()
            .then(_cancelProfileUpdate)
            .catch(console.error);
    }

    function _cancelProfileUpdate(ajaxResult) {
        var userProfileContainer = $('#myaccount-tabs-content');
        if (ajaxResult != undefined && ajaxResult.length) {
            userProfileContainer.html(ajaxResult).show();
            initMyEditableProfile();
        }
    }

    function _getUserProfileStates(value) {
        var ajaxUrl = '/Content/UserProfileGetStates/myProfileGetStates';
        var ajaxData = { countryId: value };

        SCM.Ajax.get(ajaxUrl, ajaxData)
            .expectJson()
            .then(_renderStateOptions)
            .catch(console.error);
    }

    function _renderStateOptions(result) {
        var $userProfileStates = $('.userprofile-states');
        $userProfileStates.empty();
        if (result != undefined && result.length) {
            for (var item in result) {
                var option = $('<option/>').attr('value', result[item].StateId).text(result[item].StateName);
                $userProfileStates.append(option);
            }
            $userProfileStates.removeClass('hide');
            $userProfileStates.closest('.dataRow').removeClass('hide');
        } else {
            $userProfileStates.removeClass('hide').addClass('hide');
            $userProfileStates.closest('.dataRow').addClass('hide');
        }
    }

    function _getUserProfileProfessions(value) {
        var ajaxUrl = '/Content/UserProfileGetProfessions/userProfileGetProfessions';
        var ajaxData = { isLicensedPhysician: value };

        SCM.Ajax.get(ajaxUrl, ajaxData)
            .expectJson()
            .then(_renderProfessionOptions)
            .catch(console.error);
    }

    function _renderProfessionOptions(result) {
        var $userProfileProfessions = $('.js-userprofile-professions');
        var $userProfileSpecialties = $('.js-userprofile-specialities');
        $userProfileProfessions.empty();
        $userProfileSpecialties.empty();
        if (result != undefined && result.length) {
            for (var item in result) {
                var option = $('<option/>').attr('value', result[item].ProfessionId).text(result[item].ProfessionName);
                $userProfileProfessions.append(option);
            }
            $userProfileProfessions.removeClass('hide');
            $userProfileProfessions.closest('.dataRow').removeClass('hide');
            $userProfileSpecialties.addClass('hide');
            $userProfileSpecialties.closest('.dataRow').addClass('hide');
        } else {
            $userProfileProfessions.removeClass('hide').addClass('hide');
            $userProfileProfessions.closest('.dataRow').addClass('hide');
            $userProfileSpecialties.removeClass('hide').addClass('hide');
            $userProfileSpecialties.closest('.dataRow').addClass('hide');
        }
    }

    function _getUserProfileSpecialtys(value) {
        var ajaxUrl = '/Content/UserProfileGetSpecialties/UserProfileGetSpecialties';
        var ajaxData = { professionId: value };

        SCM.Ajax.get(ajaxUrl, ajaxData)
            .expectJson()
            .then(_renderSpecialtyOptions)
            .catch(console.error);
    }

    function _renderSpecialtyOptions(result) {
        var $userProfileSpecialties = $('.js-userprofile-specialities');
        $userProfileSpecialties.empty();
        if (result != undefined && result.length) {
            for (var item in result) {
                var option = $('<option/>').attr('value', result[item].SpecialtyId).text(result[item].SpecialtyName);
                $userProfileSpecialties.append(option);
            }
            $userProfileSpecialties.removeClass('hide');
            $userProfileSpecialties.closest('.dataRow').removeClass('hide');
        } else {
            $userProfileSpecialties.removeClass('hide').addClass('hide');
            $userProfileSpecialties.closest('.dataRow').addClass('hide');
        }
    }

    function _editUserEmail() {
        var ajaxUrl = '/Content/MyEditableEmail';

        SCM.Ajax.get(ajaxUrl)
            .expectHtml()
            .then(_showEditableUserEmail)
            .catch(console.error);
    }

    function _showEditableUserEmail(ajaxResult) {
        var $userProfileContainer = $('#myaccount-tabs-content');
        if (ajaxResult != undefined && ajaxResult.length) {
            $userProfileContainer.html(ajaxResult).show();
            initUserEmailEditEvents();
        }
    }

    function _updateUserEmail() {
        var ajaxUrl = '/UserDashboard/UpdateUserEmailWithVerification/updateUserEmailWithVerification';

        var userData = {
            EmailAddress: $('#useremailchange-emailaddress').val()
        };

        SCM.Ajax.post(ajaxUrl, userData)
            .expectActionResultModel()
            .ensureSuccess()
            .then(_getUpdatedEmail)
            .catch(_updateEmailError);
    }

    function _updateEmailError(ajaxError) {
        var actionResult = ajaxError.actionResultModel;
        var $userProfileContainer = $('#myaccount-tabs-content');
        var errorMsgDiv = $userProfileContainer.find('.error-message');
        errorMsgDiv.html(_createErrorList(actionResult.Messages));
        errorMsgDiv.removeClass('hide');
    }

    function _getUpdatedEmail(ajaxResponse) {
        var ajaxUrl = '/Content/MyProfile/myProfile';
        var successHtml = ajaxResponse.Html;

        SCM.Ajax.get(ajaxUrl)
            .expectHtml()
            .then(_showUpdatedProfile)
            .then(function (result) {
                _revealSuccessMsg(successHtml);
            })
            .catch(console.error);
    }

    function _createErrorList(messages = []) {
        if (messages.length) {
            const $errorList = $('<ul></ul>');
            messages.map(errorMessage => $errorList.append(`<li>${errorMessage}</li>`));
            return $errorList;
        }
        return '';
    }

})(jQuery);